export default class CardDatesDelivery extends HTMLDivElement {
    constructor() {
        super();
        this.catalogueId = this.dataset.catalogueId;
        this.updateRoute = this.dataset.updateRoute;
        this._listeners = { radio: null, remove: null }; // gestion des listeners
    }

    connectedCallback() {
        this.reinit();
    }

    reinit() {
        // re-sélectionner les éléments dynamiques (le DOM a pu changer)
        this.removeExceptionalDelivery = this.querySelector('.remove-exceptional-delivery');

        // (ré)attacher les listeners de façon idempotente
        this.initRadio();
        this.initRemoveExceptionalDelivery();
    }

    initRadio() {
        // Annule les éventuels anciens listeners
        this._listeners.radio?.abort();
        this._listeners.radio = new AbortController();

        // Re-sélectionner les radios *maintenant* (pas en constructor)
        const radios = this.querySelectorAll('input[type="radio"]');

        radios.forEach((currentRadio) => {
            currentRadio.addEventListener('change', (event) => {
                if (event.target.checked) {
                    // data-exceptional : radio de la livraison exceptionnelle, on conserve l'info côté back
                    this.updateQuantityInDatabase({ [event.target.value]: { delivery_date: event.target.value, is_exceptional: event.target.dataset.exceptional === '1' } });
                }
            }, { signal: this._listeners.radio.signal });
        });
    }

    updateQuantityInDatabase(datasUpdated) {
        fetch(this.updateRoute, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            body: JSON.stringify({ datas_updated: datasUpdated }),
        })
            .then(r => r.json())
            .then(data => {
                this.refreshTemplates(data.templates);
                // Après refresh, le DOM de la carte a peut-être changé -> reinit
                this.reinit();
            })
            .catch(console.error);
    }

    refreshTemplates(templates) {
        if (typeof templates === 'object') {
            for (const [name, content] of Object.entries(templates)) {
                if (typeof content !== 'string') continue;
                const els = document.querySelectorAll(`[data-cart-template="${name}"]`);
                for (const el of els) {
                    el.innerHTML = content;

                    // (facultatif) si des <div is="card-dates-delivery"> arrivent via ce HTML,
                    // on peut forcer l'upgrade et reinit :
                    try { customElements.upgrade?.(el); } catch (_) {}
                    el.querySelectorAll?.('div[is="card-dates-delivery"]').forEach((node) => {
                        // Le node est déjà une instance (upgradé) si la définition existe.
                        node.reinit?.();
                    });
                }
            }
        }
    }

    initRemoveExceptionalDelivery() {
        // Annule l'ancien listener si existait
        this._listeners.remove?.abort();
        this._listeners.remove = new AbortController();

        if (!this.removeExceptionalDelivery) return;

        this.removeExceptionalDelivery.addEventListener('click', (event) => {
            event.preventDefault();

            swal.fire({
                title: 'Êtes-vous sûr de vouloir supprimer cette date de livraison exceptionnelle ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, supprimer',
                cancelButtonText: 'Annuler',
            }).then((result) => {
                if (!result.value) return;

                fetch(this.removeExceptionalDelivery.dataset.route, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                })
                    .then(r => r.json())
                    .then(data => {
                        this.classList.add('hide');
                        const exceptionalZone = this.querySelector('.radio-card');
                        if (exceptionalZone) exceptionalZone.innerHTML = '';
                        this.refreshTemplates(data.templates);
                        this.reinit();
                    })
                    .catch(console.error);
            });
        }, { signal: this._listeners.remove.signal });
    }
}
